
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['query', 'kind']

  connect() {
    this.format()
  }

  format() {
    if (this.kindTarget.value === 'cpf') {
      this.formatCpf()
    } else if (this.kindTarget.value === 'phone_number') {
      this.formatPhoneNumber()
    }
  }

  formatCpf() {
    let value = this.queryTarget.value.replace(/\D/g, "")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    this.queryTarget.value = value
  }

  formatPhoneNumber() {
    let value = this.queryTarget.value.replace(/\D/g, "")
    value = value.replace(/(\d{2})(\d)/, "($1) $2")
    value = value.replace(/(\d{4,5})(\d{4})$/, "$1-$2")
    this.queryTarget.value = value
  }
}
